import React from 'react';
import '../styles/index.less.js';
import classNames from 'classnames';
import { isFunction } from 'lodash';

var TiRadio = function TiRadio(props) {
  var _a;
  var value = props.value,
    disabled = props.disabled,
    onChange = props.onChange,
    checked = props.checked,
    defaultChecked = props.defaultChecked,
    children = props.children;
  var isChecked = checked || defaultChecked || false;
  var handleChange = function handleChange(event) {
    if (disabled) {
      return;
    }
    if (isFunction(onChange)) {
      onChange(event);
    }
  };
  var radioCls = classNames('ti-radio-wrap', (_a = {}, _a['ti-radio-disabled'] = disabled, _a['ti-radio-checked'] = isChecked, _a));
  return /*#__PURE__*/React.createElement("label", {
    className: radioCls
  }, /*#__PURE__*/React.createElement("span", {
    className: "ti-radio"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ti-radio-inner"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ti-radio-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "ti-radio-input",
    type: "radio",
    value: value,
    checked: isChecked,
    onChange: handleChange
  }))), /*#__PURE__*/React.createElement("span", {
    className: "ti-radio-label"
  }, children));
};

export { TiRadio as default };
